import { render, staticRenderFns } from "./deng.vue?vue&type=template&id=5ec77850&scoped=true&"
import script from "./deng.vue?vue&type=script&lang=js&"
export * from "./deng.vue?vue&type=script&lang=js&"
import style0 from "./deng.vue?vue&type=style&index=0&id=5ec77850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec77850",
  null
  
)

export default component.exports